import * as React from 'react'
import _ from 'underscore'

import FilterSelect from './filter_select'

const { I18n } = window as any

type FilterProps = {
  dictionaries: any
  currentElementGroup: number
  currentDepartment: number
  currentElementSubGroup: number
  currentTemplate: number
  searchTerm: string
  templates: Array<{ id: string; name: string }>
  loadTemplates: (params: any) => void
  selectElementGroup: (value: string) => void
  selectElementSubGroup: (value: string) => void
  selectDepartment: (value: string) => void
  loadTemplate: (value: string) => void
  searchTemplate: (term: string) => void
  templatesLoading?: boolean
  currentTemplateLoading?: boolean
  filtered: {
    elementSubGroups: Array<string>
    departments: Array<string>
  }
}

class Filter extends React.Component<FilterProps> {
  componentDidMount() {
    this.dispatchLoadTemplates()
  }

  componentDidUpdate(prevProps) {
    if (this.filterPropsChanged(prevProps)) {
      this.dispatchLoadTemplates()
    }
  }

  filterPropsChanged(prevProps) {
    const filterProps = ['currentElementGroup', 'currentElementSubGroup', 'currentDepartment']
    return _.any(filterProps, (p) => {
      if (_.isNaN(this.props[p]) && (_.isNaN(prevProps[p]) || _.isNull(prevProps[p]))) {
        return false
      }
      return this.props[p] != prevProps[p]
    })
  }

  dispatchLoadTemplates() {
    const params: any = {}
    if (this.props.currentElementGroup) {
      params.group = this.props.currentElementGroup
    }
    if (this.props.currentElementSubGroup) {
      params.sub_group = this.props.currentElementSubGroup
    }
    if (this.props.currentDepartment) {
      params.department = this.props.currentDepartment
    }
    this.props.loadTemplates(params)
  }

  templatesToOptionsArray(): Array<[string, string]> {
    const { templates } = this.props
    if (templates) {
      return templates.map((t): [string, string] => [t.name, t.id])
    }
    return []
  }

  filterOptions(options, filteredIds) {
    return options.filter((o) => filteredIds.includes(o[1]))
  }

  render() {
    const selectSize = 13
    return (
      <div className="order-form-filter">
        <div className="order-elements-template-filters">
          <FilterSelect
            elementId="element_group"
            label={I18n.t('activerecord.models.elements/group.one')}
            blankLabel={I18n.t('elements.order_form.blank_element_group')}
            size={selectSize}
            selectedValue={this.props.currentElementGroup}
            handleChange={this.props.selectElementGroup}
            selectOptions={this.props.dictionaries.elementGroups}
          />

          <FilterSelect
            elementId="element_sub_group"
            label={I18n.t('activerecord.models.elements/sub_group.one')}
            blankLabel={I18n.t('elements.order_form.blank_element_subgroup')}
            size={selectSize}
            selectedValue={this.props.currentElementSubGroup}
            handleChange={this.props.selectElementSubGroup}
            selectOptions={this.filterOptions(
              this.props.dictionaries.elementSubGroups,
              this.props.filtered.elementSubGroups
            )}
            showOverlay={this.props.templatesLoading}
          />

          <FilterSelect
            elementId="element_department"
            label={I18n.t('activerecord.models.lists/department.one')}
            blankLabel={I18n.t('elements.order_form.blank_department')}
            size={selectSize}
            selectedValue={this.props.currentDepartment}
            handleChange={this.props.selectDepartment}
            selectOptions={this.filterOptions(this.props.dictionaries.departments, this.props.filtered.departments)}
            showOverlay={this.props.templatesLoading}
          />

          <FilterSelect
            elementId="element_template"
            label={I18n.t('activerecord.models.elements/template.one')}
            blankLabel={I18n.t('elements.order_form.choose_element')}
            size={selectSize}
            searchEnabled
            searchTerm={this.props.searchTerm}
            selectedValue={this.props.currentTemplate}
            handleChange={this.props.loadTemplate}
            handleSearchChange={this.props.searchTemplate}
            selectOptions={this.templatesToOptionsArray()}
            showOverlay={this.props.templatesLoading || this.props.currentTemplateLoading}
          />
        </div>
      </div>
    )
  }
}

export default Filter
